import { render, staticRenderFns } from "./OrderCell.vue?vue&type=template&id=2b1530e5"
import script from "./OrderCell.vue?vue&type=script&lang=js"
export * from "./OrderCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports